export default __webpack_public_path__ + "static/media/mon_24.9b507a76.png";